(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-hero"] && !Shopify.designMode) return;
  try {
    
class HeroSlideshow{constructor(e){this.container=e,this.slides=e.querySelectorAll(".hero-slideshow__slide"),this.dots=e.querySelectorAll(".hero-slideshow__dot"),this.prevBtn=e.querySelector(".hero-slideshow__nav--prev"),this.nextBtn=e.querySelector(".hero-slideshow__nav--next"),this.currentSlide=0,this.autoplay="true"===e.dataset.autoplay,this.autoplaySpeed=1e3*parseInt(e.dataset.autoplaySpeed)||5e3,this.autoplayTimer=null,this.init()}init(){this.slides.length<=1||(this.prevBtn?.addEventListener("click",()=>this.prev()),this.nextBtn?.addEventListener("click",()=>this.next()),this.dots.forEach((e,t)=>{e.addEventListener("click",()=>this.goToSlide(t))}),this.autoplay&&(this.startAutoplay(),this.container.addEventListener("mouseenter",()=>this.stopAutoplay()),this.container.addEventListener("mouseleave",()=>this.startAutoplay())),this.pauseInactiveVideos())}goToSlide(e){this.slides[this.currentSlide].classList.remove("hero-slideshow__slide--active"),this.dots[this.currentSlide]?.classList.remove("hero-slideshow__dot--active"),this.currentSlide=e,this.slides[this.currentSlide].classList.add("hero-slideshow__slide--active"),this.dots[this.currentSlide]?.classList.add("hero-slideshow__dot--active"),this.pauseInactiveVideos()}next(){const e=(this.currentSlide+1)%this.slides.length;this.goToSlide(e)}prev(){const e=(this.currentSlide-1+this.slides.length)%this.slides.length;this.goToSlide(e)}startAutoplay(){this.autoplay&&(this.autoplayTimer=setInterval(()=>this.next(),this.autoplaySpeed))}stopAutoplay(){this.autoplayTimer&&(clearInterval(this.autoplayTimer),this.autoplayTimer=null)}pauseInactiveVideos(){this.slides.forEach((e,t)=>{e.querySelectorAll("video").forEach(e=>{t===this.currentSlide?e.play().catch(()=>{}):e.pause()})})}}document.addEventListener("DOMContentLoaded",()=>{document.querySelectorAll(".hero-slideshow").forEach(e=>{new HeroSlideshow(e)})});

  } catch(e) { console.error(e); }
})();
})();
